import request from '@/utils/request'

// 库存（货品）—列表
export const stock_list = (data) => {
    return request({
        url: '/erp/base-goods/list',
        method: 'post',
        data
    })
}

// 库存（货品）—添加/修改
export const stock_update = (data) => {
    return request({
        url: '/erp/base-goods/create',
        method: 'post',
        data
    })
}

// 库存（货品）—告罄
export const stock_delete = (data) => {
    return request({
        url: '/erp/base-goods/delete',
        method: 'post',
        data
    })
}

// 库存（货品）—批次号
export const stock_batch = (data) => {
    return request({
        url: '/erp/base-goods/batch',
        method: 'post',
        data
    })
}


// 报损—列表 可以通过批次号查到详情
export const damaged_batch = (data) => {
    return request({
        url: '/erp/base-damaged/list',
        method: 'post',
        data
    })
}

// 报损—添加
export const damaged_add = (data) => {
    return request({
        url: '/erp/base-damaged/create',
        method: 'post',
        data
    })
}

// 报损—删除
export const damaged_del = (data) => {
    return request({
        url: '/erp/base-damaged/delete',
        method: 'post',
        data
    })
}

// 库存（货品）—批次号 新的
export const stock_new_batch = (data) => {
    return request({
        url: '/erp/base-goods-batch/get-batch-num',
        method: 'get',
        data
    })
}

// 库存（货品）—添加  新的
export const stock_new_create = (data) => {
    return request({
        url: '/erp/base-goods-batch/create',
        method: 'post',
        data
    })
}


// 库存（货品）—编辑货品 新的
export const stock_edit_goods = (data) => {
        return request({
            url: '/erp/base-goods/edit-goods',
            method: 'post',
            data
        })
    }
    // 库存（货品）—获取货品 新的
export const stock_new_goods = (data) => {
    return request({
        url: '/erp/base-goods/get-goods',
        method: 'get',
        data
    })
}